import { create } from 'zustand'

interface IAdminPagesStore {
  openSidebar: boolean
}

const adminPagesStore = create<IAdminPagesStore>()(() => ({
  openSidebar: false,
}))

export default adminPagesStore
